import React from 'react';
import {Icon, Text} from '@albert-io/atomic';

import type {CleverClassResult, CleverSyncResults} from './util';
import './sync-result.scss';
import type {IconProp} from '@albert-io/atomic/atoms/Icon/Icon.react';

interface Props {
  result: CleverClassResult;
}

const SyncResults = ({
  syncResults,
  className
}: {
  syncResults?: CleverSyncResults;
} & PropsWithClassNameOptional) => (
  <div className={`w-full overflow-y-auto ${className}`}>
    {syncResults &&
      syncResults.success &&
      syncResults.results.map((r) => <ClassroomSyncResult key={r.classroom_name} result={r} />)}
  </div>
);

const ClassroomSyncResult = ({result}: Props) => {
  const messageDetails = getMessageDetails(result);
  return (
    <div className='mb-x2 flex w-full justify-between'>
      <Text
        className='overflow-hidden text-left text-ellipsis whitespace-nowrap'
        title={result.classroom_name}
      >
        {result.classroom_name}
      </Text>
      <div className='center-padding mx-x1' />
      <div className='flex items-center'>
        <Text color={messageDetails.color} className='mr-x1 whitespace-nowrap'>
          {messageDetails.message}
        </Text>
        <Icon icon={messageDetails.icon} color={messageDetails.color} />
      </div>
    </div>
  );
};

const getMessageDetails = (
  result: CleverClassResult
): {
  icon: IconProp;
  color: 'negative' | 'positive' | 'tertiary';
  message: string;
} => {
  if (!result.success) {
    if (
      result.message ===
      "Class was not imported because it was not linked to a school found in Albert's system.\n"
    ) {
      return {
        icon: 'xmark',
        color: 'negative',
        message: 'No matching school in Albert'
      };
    }
    const badEmailRegex = /^The provided email '([^']+)' failed email domain validation\.$/;
    const badEmailMatch = result.message.match(badEmailRegex);
    if (badEmailMatch) {
      return {
        icon: 'xmark',
        color: 'negative',
        message: `Contains non-school emails (${badEmailMatch[1]}).`
      };
    }
    return {
      icon: 'xmark',
      color: 'negative',
      message: 'Unknown Error'
    };
  }
  if (result.status === 'archived') {
    return {
      icon: ['far', 'box-archive'],
      color: 'tertiary',
      message: 'Archived'
    };
  }
  return {
    icon: 'check',
    message: 'Synced',
    color: 'positive'
  };
};

export default SyncResults;
